document.addEventListener('DOMContentLoaded', function () {
  const variantSelects = document.querySelector('variant-selects');
  const variantRadios = document.querySelector('variant-radios');
  const featuredImage = document.querySelector('.featured-image'); // Replace with your actual featured image selector
  let hasUserSelectedVariant = false; // Track whether the user has made a selection

  // Function to show the featured image on page load
  function showFeaturedImage() {
    if (featuredImage) {
      featuredImage.classList.add('active');
    }
  }

  // Function to handle when a variant is selected
  function handleVariantChange() {
    hasUserSelectedVariant = true; // User has selected a variant
    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-"]`);

    if (this.currentVariant && this.currentVariant.featured_media) {
      mediaGalleries.forEach((mediaGallery) =>
        mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
      );
    }

    // Hide the featured image when a variant is selected
    if (featuredImage) {
      featuredImage.classList.remove('active');
    }
  }

  // Function to attach listeners to variant selectors
  function attachVariantListeners() {
    if (variantSelects) {
      variantSelects.addEventListener('change', handleVariantChange);
    }
    if (variantRadios) {
      variantRadios.addEventListener('change', handleVariantChange);
    }
  }

  // Function to ensure image switching only happens after selection
  function updateMedia() {
    if (!this.currentVariant || !this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);

    // Ensure the image changes only if the user has selected a variant
    if (hasUserSelectedVariant) {
      mediaGalleries.forEach((mediaGallery) =>
        mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
      );
    }
  }

  // Initialize the product page behavior
  showFeaturedImage();
  attachVariantListeners();
});
